export enum TypeContrato {
  //servicos
  PRINCIPAL = 'PRINCIPAL',
  PESSOA_FISICA = 'PESSOA_FISICA',
  LUCRO_REAL = 'LUCRO_REAL',
  LUCRO_PRESUMIDO = 'LUCRO_PRESUMIDO',

  OPERACIONAL = 'OPERACIONAL',
  SUBVENCAO = 'SUBVENCAO',

  //servicos
  FCVS = 'FCVS',
  INSS_MAO_DE_OBRA = 'INSS_MAO_DE_OBRA',
  EXCLUSAO_DE_ICMS_E_ST = 'EXCLUSAO_DE_ICMS_E_ST',
  ALIQUOTA_ZERO_COMBUSTIVEL = 'ALIQUOTA_ZERO_COMBUSTIVEL',

  SIMPLES_NACIONAL = 'SIMPLES_NACIONAL',
  APURACAO_ST = 'APURACAO_ST', //Exclusão de ICMS-ST da Base de Cálculo de PIS e COFINS, Dentro do simples
  PIS_COFINS_MONOFASICO_PARA_SN = 'PIS_COFINS_MONOFASICO_PARA_SN', //sinmples do principal
  EQUIPARACAO_HOSPITALAR = 'EQUIPARACAO_HOSPITALAR',

  PREVIDENCIARIO = 'PREVIDENCIARIO', //principal
  MVA = 'MVA', //Margem de valor agregado  Lucros principal
  // INSUMOS = 'INSUMOS',// principal

  ALIQUOTA_ZERO = 'ALIQUOTA_ZERO',

  NEGOCIACAO_DE_PASSIVOS = 'NEGOCIACAO_DE_PASSIVOS', // todos principal

  DEFAULT = 'DEFAULT'
}
